module.exports = __webpack_public_path__ + "img/athlete2.bfc31934.png";